import { Translator } from 'Translator';
import { filterIsActive } from 'modules/locals/utils/LocalSearchFilterHelper';
import { DEFAULT_HOSTS_PER_PAGE } from 'modules/locals/utils/LocalSearchUrlParser';
import req from 'utils/req';

export const localSearchRequest = async (filterObject: any, page: number) => {
  const newQuery = new URLSearchParams();
  if (filterObject.country) {
    newQuery.set('location.country', filterObject.country);
    if (filterObject.city) {
      newQuery.set('location.city', filterObject.city);
    }
  }

  const activeFilters = filterObject.activeFilters;
  const otherFilter = activeFilters.find(
    (activeFilter) => activeFilter.uid === 'other',
  );
  const otherFilterIsActive = filterIsActive(otherFilter);
  const familyFriendlyFilterIsActive = otherFilterIsActive
    ? otherFilter.options.some((f) => f.value === 'family-friendly')
    : false;
  if (familyFriendlyFilterIsActive) {
    newQuery.set('other.familyfriendly', 'true');
  }

  const languageFilter = activeFilters.find(
    (activeFilter) => activeFilter.uid === 'languages',
  );
  const languageFilterIsActive = filterIsActive(languageFilter);
  if (languageFilterIsActive) {
    languageFilter.options.forEach(({ name }) =>
      newQuery.append('language[]', name.toLowerCase()),
    );
  }

  const dateFromFilter = activeFilters.find(
    (activeFilter) => activeFilter.uid === 'date.from',
  );
  const dateFromFilterIsActive = filterIsActive(dateFromFilter);
  if (dateFromFilterIsActive) {
    dateFromFilter.options.forEach(({ value: date }) =>
      newQuery.append('date.from', date),
    );
  }

  const dateToFilter = activeFilters.find(
    (activeFilter) => activeFilter.uid === 'date.to',
  );
  const dateToFilterIsActive = filterIsActive(dateToFilter);
  if (dateToFilterIsActive) {
    dateToFilter.options.forEach(({ value: date }) =>
      newQuery.append('date.to', date),
    );
  }
  newQuery.set('lang', Translator.getLanguageCode());
  newQuery.set('page', page.toString());
  if (!filterObject || !newQuery.has('location.country')) {
    return {
      data: null,
      nextCursor: undefined,
    };
  }
  try {
    const resp = await req(
      `${URL_API_HOST}/api/v1/hosts/search?${newQuery.toString()}`,
    ).get();

    const totalNrOfHosts = resp?.results?.hits?.total ?? 0;

    return {
      data: resp,
      nextCursor:
        page * DEFAULT_HOSTS_PER_PAGE < totalNrOfHosts ? page + 1 : undefined,
      pageParams: [page],
    };
  } catch (error) {
    return {
      data: null,
      nextCursor: undefined,
    };
  }
};
